import Dexie from "dexie";
export const db = new Dexie("BpReact");
// Define tables and indexes
db.version(1).stores({
  sessions: "++id,key,value,date_time",
  evenodd: "++id,key,value,date_time",
  figure: "++id,key,value,date_time"
});

export const addSession = async (key, value) => {
  const currentDateTime = new Date();

  await db.sessions.put({ key: key, value: value, date_time: currentDateTime });
};

export const getAllSession = async () => {
  const allSession = await db.sessions.toArray();
  return allSession;
};

export const addEvenOdd = async (key, value) => {
  const existingList = await getAllEvenOddList();
  const currentDateTime = new Date();

  if (existingList !== undefined && existingList.length > 0) {
    let isFoundId = 0;
    for (let i = 0; i < existingList.length; i++) {
      let obj = existingList[i];
      let searchKey = obj.key;
      let keyId = obj.id;
      if (searchKey == key) {
        isFoundId = keyId;
        break;
      }
    }
    if (isFoundId !== 0) {
      await db.evenodd.update(isFoundId, {
        key: key,
        value: value,
        date_time: currentDateTime
      });
    } else {
      await db.evenodd.add({
        key: key,
        value: value,
        date_time: currentDateTime
      });
    }
  } else {
    await db.evenodd.add({
      key: key,
      value: value,
      date_time: currentDateTime
    });
  }
};

export const getAllEvenOddList = async () => {
  const allEvenodd = await db.evenodd.toArray();
  return allEvenodd;
};

export const getAllTablesList = async () => {
  debugger;
  console.log(db.tables.map((t) => t.name));
};

export const deletAllTables = async () => {
  await db.sessions.clear();
  await db.evenodd.clear();
  await db.figure.clear();
  //await db.table3.clear();
};

export const addFigure = async (key, value) => {
  const existingList = await getAllFigureist();
  const currentDateTime = new Date();
  if (existingList !== undefined && existingList.length > 0) {
    let isFoundId = 0;
    for (let i = 0; i < existingList.length; i++) {
      let obj = existingList[i];
      let searchKey = obj.key;
      let keyId = obj.id;
      if (searchKey == key) {
        isFoundId = keyId;
        break;
      }
    }
    if (isFoundId !== 0) {
      await db.figure.update(isFoundId, {
        key: key,
        value: value,
        date_time: currentDateTime
      });
    } else {
      await db.figure.add({
        key: key,
        value: value,
        date_time: currentDateTime
      });
    }
  } else {
    await db.figure.add({ key: key, value: value, date_time: currentDateTime });
  }
};

export const getTimeDifference = async (start, end) => {
  const diffMs = new Date(end) - new Date(start);

  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

  return `${hours}h ${minutes}m ${seconds}s`;
};

 

export const getAllFigureist = async () => {
  const allFigureList = await db.figure.toArray();
  /*if (
    allFigureList !== null &&
    allFigureList !== undefined &&
    allFigureList.length > 0
  ) {
    for (let i = 0; i < allFigureList.length; i++) {
      let obj = allFigureList[i];
      let dateTime = obj.date_time;

      if (dateTime == undefined) {
         
      } else {
      }
    }
  }*/

  return allFigureList;
};



